import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { capitalizeFirstLetter, checkUndefine, vietnameseStringToUnicode, columnsTable } from '../../../../../../helpers/functions';
import {
    FormWrapperItem,
    FormWrapperInputComponent,
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import { Option } from '../../../../common/component/Select';
import Maps from "../../../../common/component/Maps";
import { Select, Switch, Table } from "antd";
import Input from "../../../../common/component/Input";
import { find, get } from 'lodash';

import './styles.less';
import { DETAIL_ACTIONS, INSTALLMENT as INSTALLMENT_ENUM } from '../../../../../../constants/Define';

class AddressInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    render() {
        const { t, golf, provinces, locations, validation, action, tagGroups } = this.props;
        const { } = this.state;
        const isInstallment = golf.installmentFee || golf.installmentLimit
        return (
            <Wrapper className="address-info-section">
                <h3 className={`ml-3`}>{t('item.homestay.addressInfo')}</h3>
                <FormWrapperItem>
                    
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent labelTitle={t(`item.homestay.address`)}>
                            <Maps.AddressInput value={checkUndefine(golf.address)} onChange={this.onChangeAddress} onSelect={this.props.onSelectPlace} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent 
                            labelTitle={t(`item.golf.linkGoogleMap`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >

                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`googleMapUrl`} onChange={(e) => this.props.onChange('googleMapUrl', e.target.value)}
                                value={golf.googleMapUrl} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={golf.locationId}
                            validation={validation.locationId}
                            labelTitle={t(`item.homestay.location`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Select className="select-location"
                                showSearch filterOption={this.selectFilterSearch}
                                showArrow
                                placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.homestay.location")).toLowerCase())}
                                value={golf.locationId}
                                onChange={this.onChangeLocation}
                                style={{ width: '100%' }}
                            >
                                {locations.map(l => (
                                    <Select.Option key={l.id} value={l.id}>{l.name}</Select.Option>
                                ))}
                            </Select>
                        </FormWrapperInputComponent>
                    </Wrapper>

                </FormWrapperItem>
            </Wrapper>
        );
    }

    onChangeAddress = (e) => {
        return this.props.onChange && this.props.onChange('address', (e.target.value || '').trimLeft());
    }

    onChangeLocation = (locationId) => {
        return this.props.onChange('locationId', locationId);
    }

    onChangeProvince = (provinceId) => {
        const province = find(this.props.provinces || [], p => p.id === provinceId);
        return this.props.onChange('province', province);
    }

    onPositionChange = (marker, event, index) => {
        if (event.position) {
            const position = {
                lat: event.position.lat(),
                lng: event.position.lng(),
            }
            this.props.onChange && this.props.onChange('position', position);
        }
    }

    selectFilterSearch = (input, option) => {
        const optionText = vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    renderTagsHomestay = ()=> {
        const { t, tagGroups } = this.props;
        const columns = {
            name: {
                key: 'name',
                width: 200
            },
            isActiveListing: {
                key: 'isActiveListing',
                width: 150,
                align: 'center',
                render: (value, record, idx)=>
                    <Switch
                        checked={value}
                        onChange={value => this.props.onChangeTags('isActiveListing', value, idx)}
                    />
                    
                
            }
        };
   
        return (
            <Table 
                columns={columnsTable({
                    titleTable: ['name', 'isActiveListing'],
                    component: columns,
                    itemName: 'homestay.homestayTags'
                })}
                dataSource={tagGroups || []} 
                size="small" 
                className="table-tag-homestay"
            />
        )
    }

}

export default withTranslation()(AddressInfo);
